<!-- Leftside panel starts here -->
@if (isLoading) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
<div class="left-section filter">
  <div class="form-row nav flex-column p-1">
    <div class="wrapper">
      <div class="main-part">
        <button
          mat-button
          class="btn btn-apply"
          type="button"
          [disabled]="
            searchWord.length < 2 ||
            searchWord.length > 100 ||
            isLoading === true ||
            isSearchDisabled() ||
            hasInvalidSearchChars ||
            hasUnbalancedQuotes ||
            hasQuotesNotAtBoundaries ||
            hasShortQuotedTerm
          "
          (click)="onSearch()"
        >
          Apply
        </button>
      </div>
      <div class="minor-part">
        <button mat-button class="clear-all" (click)="ClearAll()">
          Clear All
        </button>
      </div>
    </div>

    <div class="cheader">
      <div class="d-flex justify-content-between box-header text-white">
        <div>
          <p class="triangle-bottomleft"><mat-icon>search</mat-icon>Search</p>
        </div>
        <div class="align-self-end p-2">
          <mat-icon class="help-info" (click)="openHelpInfo($event, 18)"
            >info</mat-icon
          >
        </div>
      </div>
      <input
        id="SearchFilterInput"
        type="text"
        class="form-control form-control-sm mt-2 input-lg"
        placeholder="Enter a search term then click Apply"
        [(ngModel)]="searchWord"
        (keyup.enter)="
          searchWord.length >= 2 &&
            searchWord.length <= 100 &&
            !isLoading &&
            !isSearchDisabled() &&
            !hasInvalidSearchChars &&
            !hasUnbalancedQuotes &&
            !hasQuotesNotAtBoundaries &&
            !hasShortQuotedTerm &&
            onSearch()
        "
      />
      @if (hasInvalidSearchChars) {
        <small class="search-term-warning">
          Unsupported characters: * ? ! ^ ~ : \
        </small>
      }
      @if (hasUnbalancedQuotes) {
        <small class="search-term-warning">
          Unclosed quote — wrap your phrase in matching quote marks, e.g. "exact phrase"
        </small>
      }
      @if (!hasUnbalancedQuotes && hasQuotesNotAtBoundaries) {
        <small class="search-term-warning">
          Quotes must wrap the entire search term, e.g. "exact phrase"
        </small>
      }
      @if (!hasUnbalancedQuotes && !hasQuotesNotAtBoundaries && hasShortQuotedTerm) {
        <small class="search-term-warning">
          Quoted phrases must contain at least 2 characters.
        </small>
      }
      <!--div class="search-button-container" style="visibility: hidden">
        <div class="search-button-group">
          <button
            mat-button
            class="btn btn-search-clear"
            type="button"
            (click)="onAdvancedSearch()"
          >
            Advanced Search
          </button>
          <mat-icon
            class="help-info help-info-close"
            (click)="openHelpInfo($event, 18)"
            >info</mat-icon
          >
        </div>
        <button mat-button>Clear Advanced Search</button>
      </div>
    </div-->

      <div class="d-flex justify-content-between box-header text-white mb-1">
        <div class="triangle-bottomleft-remove compare-header">
          <mat-icon class="fa fa-info-circle pointer">filter_alt</mat-icon>
          <span>Filter</span>
        </div>
      </div>

      <div id="accordJur" class="position-relative" #accordJur>
        <div header="Jurisdiction" class="pointer-none">
          <div class="ui-accordion-header ui-state-default ui-corner-all">
            <div class="panel-body pt-0 button-bar" (click)="showJurPopup()">
              <div class="p-0 rc-item">
                <p>Jurisdictions</p>
                <div class="icon-right">
                  <mat-icon
                    class="item-selected"
                    [hidden]="
                      !filterJurisdictions || filterJurisdictions.length == 0
                    "
                    >check</mat-icon
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="accordTopic" class="position-relative" #accordTopic>
        <div header="Topic" class="pointer-none">
          <div class="ui-accordion-header ui-state-default ui-corner-all">
            <div class="panel-body pt-0 button-bar" (click)="showTopicPopup()">
              <div class="p-0 rc-item">
                <p>Topics</p>
                <div class="icon-right">
                  <mat-icon
                    class="item-selected"
                    [hidden]="!filterTopics || filterTopics.length == 0"
                    >check</mat-icon
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="accordQuestionType" class="position-relative">
        <div header="Question Type" class="pointer-none">
          <div class="ui-accordion-header ui-state-default ui-corner-all">
            <div class="panel-body pt-0 button-bar">
              <div class="p-0 rc-item">
                <p>Question Type</p>
                <div class="icon-right">
                  <mat-checkbox
                    [checked]="rulebookChecked"
                    class="question-type-checkbox"
                    (change)="onQuestionTypeChange('rulebook', $event.checked)"
                    >Rulebook</mat-checkbox
                  >
                  <mat-checkbox
                    [checked]="applicabilityChecked"
                    class="question-type-checkbox"
                    (change)="
                      onQuestionTypeChange('applicability', $event.checked)
                    "
                    >Applicability</mat-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-between box-header text-white mb-1 saved-search-header"
      >
        <div
          class="triangle-bottomleft-remove compare-header"
          [ngClass]="this.selectedDefinitionId == 0 ? 'disable' : 'runnable'"
          (click)="onSearch()"
        >
          <mat-icon
            class="fa fa-info-circle pointer"
            [ngClass]="this.selectedDefinitionId == 0 ? 'disable' : 'runnable'"
            >restore</mat-icon
          >
          <span>Run a Saved Search</span>
        </div>
      </div>

      <mat-accordion id="accordSaved" class="position-relative" #accordSaved>
        <mat-expansion-panel
          (opened)="openSearchDef()"
          (closed)="isSearchDefPanelOpen = false; clearSelection()"
        >
          <mat-expansion-panel-header
            class="ui-accordion-header ui-state-default ui-corner-all"
          >
            <mat-panel-title class="panel-body pt-0">
              Saved Searches
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex justify-content-end mb-2">
            <div class="minor-part">
              <button
                mat-button
                class="clear-all clear-selection"
                [disabled]="selectedDefinitionId === 0"
                (click)="clearSelection()"
              >
                Clear Selection
              </button>
            </div>
          </div>
          <input
            id="SavedSearchName"
            type="text"
            class="form-control form-control-sm mt-2 mb-1 input-lg"
            placeholder="Search ..."
            (input)="onSearchDefinition($event.target.value)"
          />
          <div>
            <mat-radio-group>
              <div class="saved-search-item" *ngFor="let cd of displayDef">
                <mat-radio-button
                  class="radiobutton"
                  [name]="'savedSearch'"
                  [checked]="isDefinitionSelected(cd.id)"
                  [value]="cd.id"
                  (change)="onDefinitionSelected(cd.id)"
                >
                  {{ cd.searchName }}
                </mat-radio-button>
                <div class="search-details">
                  <div class="left-details">
                    <mat-icon class="calendar-icon">event</mat-icon>
                    <span class="created-date"
                      >Created on {{ cd.createdDate | date: "M/d/yyyy" }}</span
                    >
                  </div>
                  <mat-icon
                    class="deleteButton"
                    (click)="onDeleteSearchDefinition(cd.id, cd.searchName)"
                    matTooltip="Delete saved search"
                    mattooltipclass="tooltip2"
                  >
                    delete
                  </mat-icon>
                </div>
              </div>
            </mat-radio-group>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
